import { Suspense, lazy } from '@wordpress/element'

const Leaflet = lazy( () => import( "./leaflet" ) );
const LeafletMarkerCluster = lazy( () => import( "./markercluster" ) );

// mit sw-immoapp syncen

export default {
	Leaflet: ( props: { children: any } ) => {
		return (
			<Suspense fallback={ <span></span> }>
				<Leaflet>{ props.children }</Leaflet>
			</Suspense>
		)
	},

	LeafletMarkerCluster: ( props: { children: any } ) => {
		return (
			<Suspense fallback={ <span></span> }>
				<LeafletMarkerCluster>{ props.children }</LeafletMarkerCluster>
			</Suspense>
		)
	}
}
